import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tabs, Card } from 'antd';
import { Link } from 'react-router';
import { setContractTab } from '@store/modules/incubator/contract_tab';

import DateCondition from '@comm/search/DateSearch';
import ComArchived from './ComArchived';
// import ComArchiving from "./ComArchiving";
import ComConclude from './ComConclude';

const { TabPane } = Tabs;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      condition: {},
    };
  }

  componentWillMount() {
    this.pageDisplay = {};
  }

  componentDidMount() {}

  // 离开页面时，保存当前页面的状态
  componentWillUnmount() {
    const { dimenUuid } = this.props;
    this.props.dispatch(
      setContractTab({
        tab: this.tab,
        ...dimenUuid,
        ...this.pageDisplay,
      }),
    );
  }

  onPageChange = key => (type, page, pageSize) => {
    this.pageDisplay[`${key}Page`] = page;
    this.pageDisplay[`${key}Type`] = type;
    pageSize && (this.pageDisplay[`${key}PageSize`] = pageSize);
  };

  callback = key => {
    this.tab = key;
  };

  onChange = e => {};

  handleChange = params => {
    this.setState({
      condition: { ...params },
    });
  };

  render() {
    const uuid = this.props.params.uuid || ''; // 孵化器uuid
    // const addresssLink = uuid
    //   ? `/incubator/one/${uuid}/contract/address`
    //   : `/incubator/contract/address/add`;
    const stationLink = uuid
      ? `/incubator/one/${uuid}/contract/station`
      : `/incubator/contract/station/add`;
    const extra = (
      <div>
        {/* <Link style={{ paddingLeft: "8px" }} to={addresssLink}>
          添加地址合同
        </Link> */}
        <Link style={{ paddingLeft: '8px' }} to={stationLink}>
          添加基础孵化合同
        </Link>
      </div>
    );
    const { dimenUuid, contractTabStore } = this.props; // 客户首页、合同首页参数不同

    // 非返回进入页面，初始化页面状态
    let contractTab = {};
    if (
      contractTabStore.incubatorUuid === dimenUuid.incubatorUuid &&
      dimenUuid.customUuid === contractTabStore.customUuid
    ) {
      this.tab = contractTabStore.tab || '1';
      contractTab = contractTabStore;
    }
    const parentProps = {
      contractTab,
      dimen: this.props.dimen,
      status,
      pageSize: this.props.pageSize || 10,
      condition: { ...this.state.condition, ...dimenUuid },
    };

    return (
      <Card title="合同管理" extra={dimenUuid.customUuid ? null : extra}>
        <DateCondition onChange={this.handleChange} />
        <Tabs defaultActiveKey={this.tab || '1'} onChange={this.callback}>
          <TabPane tab="在签合同" key="1">
            <ComConclude {...parentProps} onPageChange={this.onPageChange('conclude')} />
          </TabPane>
          {/* <TabPane tab="待归档合同" key="2">
            <ComArchiving
              {...parentProps}
              onPageChange={()=> this.onPageChange("archiving")}
            />
          </TabPane> */}
          <TabPane tab="归档合同" key="3">
            <ComArchived {...parentProps} onPageChange={this.onPageChange('archived')} />
          </TabPane>
        </Tabs>
      </Card>
    );
  }
}

export default connect(state => ({ contractTabStore: state.contract_tab }))(Index);



// WEBPACK FOOTER //
// ./src/components/incubator/contract/index/ComponentContract.js